<template>
  <NuxtLayout :name="layout">
    <client-only>
      <user-account-section v-if="isLoggedIn">
        <template #header>
          <translate>Account details</translate>
        </template>
        <user-account-details />
      </user-account-section>
    </client-only>
    <nuxt-to-meta :nuxt2meta="head" />
  </NuxtLayout>
</template>

<script setup lang="ts">
definePageMeta({
  layout: false,
  middleware: 'auth-redirect',
})

const { $isDesktop } = useNuxtApp()
const authStore = useAuthStore()

const head = computed(() => {
  return {
    title: (useI18n().t('Account details') as string) + ' | Pitchup.com',
    meta: [
      {
        hid: 'robots',
        name: 'robots',
        content: 'noindex',
      },
    ],
    bodyAttrs: {
      class: 'account-home',
    },
  }
})

const isLoggedIn = computed(() => authStore.isLoggedIn)

const layout = computed(() => {
  return $isDesktop ? 'user-account-desktop' : 'user-account'
})
</script>
